import * as yup from 'yup'; 

export const schema = yup.object().shape({
  cnpj: yup.string().required('CNPJ deve ser informado').length(14, 'Preencha corretamente o CNPJ'),
  corporateName: yup.string().required('Razão social deve ser informado'),
  tradeName: yup.string().required('Nome fantasia deve ser informado'),
  email: yup.string().email('É necessário que seja um e-mail válido').required('E-mail deve ser informado'),
  phone: yup.string().required('Telefone deve ser informado')

})